export default{
    getUrlKey:function(name){
        return decodeURIComponent((new RegExp('[?|&]'+name+'='+'([^&;]+?)(&|#|;|$)').exec(location.href)||[,""])[1].replace(/\+/g,'%20'))||null;
    }
    ,isApp:function(){
        var isAppFlag=false
        if (navigator.userAgent.indexOf('KTX') != -1) {
            isAppFlag = true
        } else {
            isAppFlag = false
        }
        // if (this.$route.query.isApp) {
        //     isAppFlag = true
        // }
        return isAppFlag;
    },isWechat:function(){
        var isWechatFlag=false
        if (navigator.userAgent.toLowerCase().indexOf('micromessenger') != -1) {
            isWechatFlag = true
        }
        return isWechatFlag;
    },isQQ:function(){
        var isWechatFlag=false
        // alert(11)
        if (navigator.userAgent.toLowerCase().indexOf('qq') != -1) {
            isWechatFlag = true
        }
        return isWechatFlag;
    },isWeibo:function(){
        var isWechatFlag=false
        // alert(11)
        if (navigator.userAgent.toLowerCase().indexOf('weibo') != -1) {
            isWechatFlag = true
        }
        return isWechatFlag;
    },
    deepLink:function(url){
        console.log('utils.deeplink:'+url)
        var share1 = document.createElement("iframe");
        share1.src = url;
        share1.setAttribute('class','localiframe')
        var s1 = document.getElementsByTagName("script")[0];
        s1.parentNode.insertBefore(share1, s1);
        setTimeout(function (){
            s1.parentNode.removeChild(share1)
        },500)
}
}



// WEBPACK FOOTER //
// ./src/service/utils.js